import { z } from 'zod'

export const GetRoleSchema = z.object({
  id: z.number(),
  name: z.string(),
})

export const GetRoleWithTimestampsSchema = z.object({
  created_at: z.coerce.date(),
  id: z.number(),
  name: z.string(),
  updated_at: z.coerce.date(),
})

export type Role = z.infer<typeof GetRoleSchema>
export type RoleWithTimestamps = z.infer<typeof GetRoleWithTimestampsSchema>
